import { Grid, Typography } from '@mui/material';
import './Footer.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart } from '@fortawesome/free-solid-svg-icons';


const Footer = () => {
    return (
        <>
            <Grid sx={
                {
                    background: '#f7f8fd',
                    color: '#000000',
                    textAlign: 'center',
                    paddingY: 5,
                }
            }>
                <div>
                    <Typography> Copyright © 2023 Nyaya Saarathi All Rights Reserved

</Typography>
                </div>
            </Grid>
        </>
    )
}

export default Footer;
